<template>
  <CarouselBanner
    :ga-action="'listen_banner_click'"
    :banner-orin-data="bannerData"
    :banner-duration="bannerDuration"
  />
</template>

<script>
import CarouselBanner from '@/components/common/CarouselBanner.vue'
import CarouselService from '@/assets/services/CarouselService'

export default {
  name: 'ListenBanner',
  components: {
    CarouselBanner
  },
  props: {},
  data() {
    return {
      bannerDuration: 6000,
      bannerData: []
    }
  },
  computed: {},
  watch: {
    bannerData(newVal) {
      this.bannerData = newVal
    }
  },
  created() {},
  beforeDestroy() {
  },
  mounted() {
    this.getBannerData()
  },
  methods: {
    async getBannerData() {
      const banners = await CarouselService.getBanners('listen')
      if (banners) {
        this.bannerData = banners.bannerData
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.mk-banner{
  margin-top: 16px;
}

@keyframes turning-disc {
  from {
    width: 41.63%;
    left: -8.92%;
    top: 0;
    bottom: 0;
    margin: auto 0;
    transform: rotate(0deg);
    height: auto;
  }
  to {
    width: 41.63%;
    left: -8.92%;
    top: 0;
    bottom: 0;
    margin: auto 0;
    transform: rotate(360deg);
    height: auto;
  }
}

@keyframes turning-disc-small {
  from {
    width: 75%;
    left: -16%;
    top: 0;
    bottom: 0;
    margin: auto 0;
    transform: rotate(0deg);
    height: auto;
  }
  to {
    width: 75%;
    left: -16%;
    top: 0;
    bottom: 0;
    margin: auto 0;
    transform: rotate(360deg);
    height: auto;
  }
}

@media only screen and (min-width: 1440px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
}
@media only screen and (max-width: 767.98px) {
}
</style>
